import { on } from './app/store'

/**
 * The header lives outside the Swup container, so its active state has to
 * follow client-side visits.
 */
const normalize = (url) => {
  const { origin, pathname } = new URL(url, window.location.href)
  return origin + pathname.replace(/\/+$/, '')
}

export function updateActiveNav() {
  const current = normalize(window.location.href)

  document.querySelectorAll('[data-nav-link]').forEach((link) => {
    const active = normalize(link.href) === current
    link.classList.toggle('is-active', active)
    if (active) {
      link.setAttribute('aria-current', 'page')
    } else {
      link.removeAttribute('aria-current')
    }
  })
}

export function startNav() {
  updateActiveNav()
  on('page-view', updateActiveNav)
}
